import React, { useEffect, useState } from 'react'
import { useStateValue } from '../../StateProvider';
import './Contact.css'
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import GitHubIcon from '@material-ui/icons/GitHub';
import IconButton from '@material-ui/core/IconButton';
import axios from '../../axios'
import {useTranslation} from "react-i18next";


function Contact() {
    const ContactContainer = React.createRef();
    const [state, dispatch] = useStateValue();
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
    const {t, i18n} = useTranslation('common');
    const handleSend = async(e) => {
        e.preventDefault();
        await axios.post('/newMessage' ,{
         name :  name,
         email : email,
         subject : subject,
         message: message
        }).then(response => {
            setName('')
            setEmail('')
            setSubject('')
            setMessage('')
            alert(response.data)
        })
    }
    useEffect(() => {
        dispatch({
            type : "ADD_REF",
            ref : ContactContainer.current.offsetTop
        })
        dispatch({
            type : "ADD_REF",
            ref : ContactContainer.current.offsetTop + ContactContainer.current.offsetHeight
        })
    }, [])
    return (
        <div ref={ContactContainer} className="contact">
            <div className="contact__header">
                <p>{t('contact.p1')}</p>
                <h1>{t('contact.p2')}</h1>
                <hr/>
            </div>
            <div className="contact__body">
                <div className="contact__info">
                    <h1>{t('contact.p3')}</h1>
                    <p><span><LocationOnIcon /></span>{t('contact.p4')}</p>
                    <p><span><PhoneIcon /></span>+2136 74 71 57 15</p>
                    <p><span><EmailIcon  /></span>fo_berarma@esi.dz</p>
                    <div className="contact__social">
                            <a href="https://www.facebook.com/oussama.berarma.12/" target="_blank">
                            <IconButton>
                            <FacebookIcon className="contact__social__iconButton" fontSize="large"/>
                            </IconButton>
                            </a>
                            <a href="https://www.instagram.com/oussama_berarma/" target="_blank">
                        <IconButton>
                            <InstagramIcon className="contact__social__iconButton" fontSize="large"/>
                        </IconButton>
                        </a>
                        <a href="https://github.com/ouss1919" target="_blank">
                        <IconButton>
                            <GitHubIcon className="contact__social__iconButton" fontSize="large"/>
                        </IconButton>
                        </a>
                        <a href="https://www.linkedin.com/in/oussama-berarma/" target="_blank">
                        <IconButton>
                            <LinkedInIcon className="contact__social__iconButton" fontSize="large"/>
                        </IconButton>
                        </a>
                    </div>
                </div>
                <div className="contact__input">
                    <form onSubmit={handleSend}>
                        <input value={name} onChange={e => setName(e.target.value)} type="text" placeholder={t('contact.p5')} required/>
                        <input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder={t('contact.p6')} required/>
                        <input value={subject} onChange={e => setSubject(e.target.value)} type="text" placeholder={t('contact.p7')}/>
                        <textarea value={message} onChange={e => setMessage(e.target.value)} cols="31" rows="14" placeholder={t('contact.p8')} required></textarea>
                        <input type ="submit" className="contact__button" value={t('contact.p9')} />
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contact
